module.exports = __webpack_public_path__ + "img/calendar.f7f71bd1.svg";